/**
=========================================================
* Argon Dashboard 2 PRO MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-mui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/* eslint-disable no-dupe-keys */
// Argon Dashboard 2 PRO MUI base styles
import colors from "assets/theme/base/colors";
import "chartjs-plugin-datalabels"; //for datalabels on slice of pie chart

// Default colors for pie chart slices
const defaultColors = [
  "#6C7AF2", // Blue
  "#B6C6E6", // Light Blue
  "#1B2A41", // Dark Blue
  "#6ED6F5", // Cyan
  "#FF6B6B", // Red
  "#4ECDC4", // Teal
  "#45B7D1", // Sky Blue
  "#96CEB4", // Green
];

function configs(labels, datasets) {
  const backgroundColors = [];

  if (datasets?.[0]?.backgroundColor) {
    // Use provided background colors
    datasets?.[0]?.backgroundColor.forEach((color) =>
      backgroundColors.push(color)
    );
  } else {
    // Use default colors for each data point
    const dataLength = datasets?.[0]?.data?.length || labels.length;
    for (let i = 0; i < dataLength; i++) {
      backgroundColors.push(defaultColors[i % defaultColors.length]);
    }
  }

  return {
    data: {
      labels,
      datasets: [
        {
          label: datasets?.[0]?.label,
          weight: 9,
          cutout: 0,
          tension: 0.9,
          pointRadius: 2,
          borderWidth: 2,
          backgroundColor: backgroundColors,
          fill: false,
          data: datasets?.[0]?.data,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      interaction: {
        intersect: true,
        mode: "index",
      },
      scales: {
        y: {
          grid: {
            drawBorder: false,
            display: false,
            drawOnChartArea: false,
            drawTicks: false,
          },
          ticks: {
            display: false,
          },
        },
        x: {
          grid: {
            drawBorder: false,
            display: false,
            drawOnChartArea: false,
            drawTicks: false,
          },
          ticks: {
            display: false,
          },
        },
      },
      // Add the legend configuration
      plugins: {
        legend: {
          display: false,
        },
        datalabels: {
          display: true,
          color: "#fff",
          font: {
            weight: "bold",
          },
          formatter: (value, context) => {
            return "$" + value;
          },
        },
      },
    },
  };
}

export default configs;
